var _ = require('../utils/lib.js');

var Option = function (giftProducts) {
  this.id = Date.now().toString();
  this.gift_products = this._initGiftProducts(giftProducts);
  this.line_items = [];
  // these properties are written with underscores because they are used in Liquid.

  Object.defineProperty(this, 'valid', {
    get: function () {
      return this._validate();
    }
  });

  Object.defineProperty(this, 'lineItemTitles', {
    get: function () {
      return this._getLineItemTitles().join(', ');
    }
  });
};

Option.prototype.giftOptionSelected = function (optionData) {
  this.gift_products[optionData.giftProduct].selected = optionData.selected;
};

Option.prototype.giftOptionMessage = function (optionData) {
  this.gift_products[optionData.giftProduct].message = optionData.message;
};

Option.prototype.setSelectedVariant = function (optionData) {
  var giftProduct = this.gift_products[optionData.giftProduct];
  _.each(giftProduct.variants, function (variant) {
    if (variant.id.toString() == optionData.variantID) {
      giftProduct.selected_variant = variant;
    }
  });
};

Option.prototype.addLineItem = function (lineItem) {
  this.line_items.push(lineItem);
};

Option.prototype.removeLineItem = function (lineItem) {
  if (typeof item == 'string') {
    lineItem = this._getLineItemByID(lineItem);
  }
  var lineItemIndex = this.line_items.indexOf(lineItem);
  return this.line_items.splice(lineItemIndex, 1)[0]; // pass the line item back to the options
};

Option.prototype.giftProductsForCart = function () {
  return this._getSelectedGiftProducts();
};

// Private
Option.prototype._initGiftProducts = function (giftProducts) {
  var newGiftProducts = [];
  _.each(giftProducts, function (giftProduct) {
    giftProduct = JSON.parse(JSON.stringify(giftProduct));
    giftProduct = this._decorateGiftProduct(giftProduct);
    newGiftProducts.push(giftProduct);
  }, this);
  return newGiftProducts;
};

Option.prototype._decorateGiftProduct = function (giftProduct) {
  giftProduct.selected = false;
  giftProduct.message = '';
  giftProduct.selected_variant = giftProduct.variants[0]; // first variant
  return giftProduct;
};

Option.prototype._validate = function () {
  var valid = false,
    selectedGiftProducts = this._getSelectedGiftProducts();

  // We should have at least one selected gift product
  // We should have at least one line item
  if (selectedGiftProducts.length > 0 && this.line_items.length > 0) {
    valid = true;
  }

  return valid;
};

Option.prototype._getLineItemByID = function (id) {
  var line_item;
  _.each(this.line_items, function (item) {
    if (item.id == id) {
      line_item = item;
    }
  });
  return line_item;
};

Option.prototype._getSelectedGiftProducts = function () {
  var selectedGiftProducts = [];
  _.each(this.gift_products, function (giftProduct) {
    if (giftProduct.selected) {
      selectedGiftProducts.push(giftProduct);
    }
  });
  return selectedGiftProducts;
};

Option.prototype._getLineItemTitles = function () {
  var titles = [];
  _.each(this.line_items, function (item) {
    // {{ line_item.title }}{% if line_item.properties._message %}: {{ line_item.properties._message }}{% endif %}
    var title = item.title + ((item.properties && item.properties._message)? ': '+item.properties._message : '');
    titles.push(title);
  });
  return titles;
};

module.exports = Option;
